<template>
  <div class="is-relative">
    <p class="has-text-centered" v-if="loading">
      {{ loading ? 'Analyzing portfolio...' : '&nbsp;' }}
    </p>
    <div v-if="portfolio.returns && portfolio.returns.diagnostics" class="bottomMargin">
      <b-tooltip label="Assumes daily rebalancing" position="is-bottom">
        <div  >
          <div class="level">
            <div  class="level-item has-text-centered" v-if="draftPortfolio.returns && draftPortfolio.returns.diagnostics">
              <div>
                <p class="fontSizeHalf">Draft Ann. Return</p>
                <p class="title is-7">{{ Number(draftPortfolio.returns.diagnostics.annualized_return).toFixed(2) * 100 }}%</p>
              </div>
            </div>
            <div class="level-item has-text-centered " >
              <div>
                <p class="fontSizeHalf">Current Ann. Return</p>
                <p class="title is-7">{{ Number(portfolio.returns.diagnostics.annualized_return).toFixed(2) * 100 }}%</p>
              </div>
            </div>
          </div>
          <div class="level">
            <div class="level-item has-text-centered" v-if="draftPortfolio.returns && draftPortfolio.returns.diagnostics">
              <div>
                <p class="fontSizeHalf">5Y Draft Sharpe</p>
                <p class="title is-7">{{ Number(draftPortfolio.returns.diagnostics.benchmark_sharpe).toFixed(2) }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered ">
              <div>
                <p class="fontSizeHalf">5Y Current Sharpe</p>
                <p class="title is-7">{{ Number(portfolio.returns.diagnostics.benchmark_sharpe).toFixed(2) }}</p>
              </div>
            </div>
          </div>
        </div>
        <LineChart
          v-if="portfolio.returns && portfolio.returns.diagnostics"
          :options="chartOptions"
          :chart-data="chartData()"
          :width="250"
          :height="300"
        />
        <b-loading v-model="loading" :can-cancel="false" :is-full-page="false"></b-loading>
      </b-tooltip>
    </div>
 </div>
</template>

<script>
import LineChart from '@frontend/builder/js/components/LineChart.js';


export default {
  data() {
    return {
      portfolio: {
        returns: {
          diagnostics: {
            benchmark_values: [],
          },
        },
      },
      draftPortfolio: {
        returns: {
          diagnostics: {
            benchmark_values: [],
          },
        },
      },
      optimized: {},
      optimizedPortfolio: {},
      dataLoaded: false,
      impactReport: {},
      loading: false,
      optimizerType: 'minTracking',
    };
  },
  props: {
    universe: Object,
    results: Object,
    screens: Array,
    flaggedTable: Object,
    isInPortfolioEditor: Boolean,
  },
  components: {
    LineChart,
  },
  computed: {
    chartOptions() {
      return {
        plugins: {
          legend: {
            display: true,
          },
        },
        scales: {
          y: {
            stepSize: 500,
          },
        },
      };
    },
  },
  methods: {
    chartData() {
      if (!this.portfolio?.returns?.diagnostics) {
        return {};
      }
      const datasets = [
        {
          borderColor: ['darkblue'],
          borderWidth: 1,
          data: this.portfolio.returns.diagnostics.benchmark_values,
          pointBackgroundColor: 'transparent',
          pointBorderColor: 'transparent',
          tension: 0.1,
          label: 'Current portfolio',
        },
      ];
      if (this.draftPortfolio?.returns?.diagnostics) {
        datasets.push({
          borderColor: ['orange'],
          borderWidth: 1,
          data: this.draftPortfolio.returns.diagnostics.benchmark_values,
          pointBackgroundColor: 'transparent',
          pointBorderColor: 'transparent',
          tension: 0.1,
          label: 'Draft Portfolio',
        });
      }
      const data = {
        labels: this.portfolio.returns.diagnostics.chart_dates,
        datasets,
      };
      return data;
    },
    doApiCall: async function() {
      this.loading = true;

      this.draftPortfolio = this.universe;

      const draftPortfolioResponse = await fetch('/api/v1/optimizer/daily_returns/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.$root.$data.csrfToken,
        },
        body: JSON.stringify({
          benchmarkWeights: this.draftPortfolio.holdings.reduce((acc, itm) => {
            acc[itm.id] = itm.percentage;
            return acc;
          }, {}),
        }),
      });
      const draftPortfolioResponseData = await draftPortfolioResponse.json();
      this.draftPortfolio.returns = draftPortfolioResponseData;
      this.loading = false;
    },
  },
  watch: {
    'universe.name': function() {
      this.doApiCall();
    },
    'universe.destination.id': function() {
      this.doApiCall();
    },
    'universe.holdings': {
      handler: function() {
        this.doApiCall();
      },
      deep: true,
    },
  },
  updated: async function() {
  },
  async created() {
    this.portfolio = { ...this.universe };

    const originalPortfolioResponse = await fetch('/api/v1/optimizer/daily_returns/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': this.$root.$data.csrfToken,
      },
      body: JSON.stringify({
        benchmarkWeights: this.portfolio.holdings.reduce((acc, itm) => {
          acc[itm.id] = itm.percentage;
          return acc;
        }, {}),
      }),
    });
    const originalPortfolioResponseData = await originalPortfolioResponse.json();
    this.portfolio.returns = originalPortfolioResponseData;
  },
};
</script>

<style lang="scss">
  .hackbars {
    height: 15px;
    background-color: #34a85c;

    &.left {
      background-color: #f14668;
      float:right;
    }
  }
</style>
